import { appInfo } from './version';
export const environment = {
  production: true,
  auth: {
    authServiceUrl: 'https://pws.ccsmed.com/authsrvc',
    client_id: 'cgm-ui',
    app: appInfo.name,
    env: 'Production',
    dataBase: 'ORA_PROD',
    version: appInfo.version,
    ipimsPage: 'http://ipimsdev.ccsmed.com/'
  },
  doctorSearchAPI: 'https://websvcs.ccsmed.com/cgmsrv-api/api/doctors',
  referralAPI: 'https://websvcs.ccsmed.com/cgmsrv-api',
  productAPI: 'https://websvcs.ccsmed.com/cgmsrv-api/api/cgm/products',
  reCaptchaSiteKey: '6LcJ9YoUAAAAAGS0IiIUlaFxSLHPqf0wWglceize',
  showReCaptcha: true,
  showAdditionalRoutes: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts